import React from 'react';

import type { DebugLogService } from '../common/types';

export const AsyncRovoAgentDebugModal: React.LazyExoticComponent<
	({
		source,
		debugLogService,
		onViewAgent,
		onError,
		onClose,
	}: {
		source?: string;
		debugLogService: DebugLogService;
		onViewAgent: (authorId: string) => void;
		onError?: (error: Error) => void;
		onClose: () => void;
	}) => React.JSX.Element
> = React.lazy(() =>
	import(/* webpackChunkName: "@atlassian/rovo-agent-debug-modal" */ './index').then(
		({ RovoAgentDebugModal }) => ({ default: RovoAgentDebugModal }),
	),
);
